import { Task } from "./task";
import { PaginatedResponse } from "./paginated-response";

export class ProjectSummary {
  // orders: ProjectSummaryOrder[];
  orders: OrderHistory[];
  constructor() {
    this.orders = [];
  }
}

export class PaginatedOrderHistory extends PaginatedResponse {
  records: OrderHistory[];
}

export class OrderHistory {
  projectName:string;
  shipToParty: string;
  salesOrderNumber: string;
  orderDate: string;
  customerPODate: string;
  reqDeliveryDate: string;
  poNumber: string;
  status: string;
  tasks?: Task[] = [];
  orderItems: OrderItem[];
}

export class OrderItem {
  itemNumber: string;
  sku: string;
  index: number;
  mpn: string;
  manufaturerDescription: string;
  orderQty: string;
  backorderQty: string;
  expectedShipDate: string;
  itemStatus: string;
  trackingId?: string;
  carrierName?: string;
  plannedShipDate?: string;
  carrierWebsite?: string;
  itemDescription: string;
  isSkuOnTarget: boolean;
  isParentItem: boolean;
  itemDeliveryDetails: OrderItemDeliveryDetailDto[];
}

export class ProjectSummaryOrder {
  salesOrderNumber: string;
  paymentMethod: number;
  poNumber: string;
  status: string;
  tasks?: Task[] = [];
  orderDetails: OrderDetail[];
  customerPODate: Date;
  reqDeliveryDate: Date;
}
export class OrderItemDeliveryDetailDto {

  deliveryNumber: string;
  deliveryItem: string;
  plannedShipDate: string;
  actualShipDate: string;
  deliveryQty: string;
  trackingID: string;
  carrierID: string;
  podDate: string;
  podStatus: string;
}
export class ProjectOrderSummaryFilter {
  name: string;
  value: string;
  isCallFromUI: boolean;
  constructor(name: string, value: string) {
    this.name = name;
    this.value = value;
  }
}

export class OrderDetail {
  sku: string;
  partNumber: string;
  description: string;
  qtyOrdered: number;
  qtyShipped: number;
  status?: string;
  id?: string;
  daysLate?: number;
  availabilityDate?: string;
}

export class ProjectOrderInput {
  customerNumber: string;
  projectName: string;
  serviceOrderNumber?: string;
  poSummaryFilter: ProjectOrderSummaryFilter;
  shipToParty: string;
  constructor(projectName: string, customerNumber: string, serviceOrderNumber?: string, shipToParty?:string) {
    this.projectName = projectName;
    this.customerNumber = customerNumber;
    this.serviceOrderNumber = serviceOrderNumber;
    this.shipToParty = shipToParty;
    }
}

export class ProjectOrderInputs {
  inputs: ProjectOrderInput[];
  salesOrderFilter: boolean = false;
  projectOrderSummaryFilter : boolean = false;
  constructor(salesOrderFilter: boolean, inputs?: ProjectOrderInput[],projectOrderSummaryFilter ? :boolean) {
    this.salesOrderFilter = salesOrderFilter;
    this.projectOrderSummaryFilter = projectOrderSummaryFilter;
    if (inputs) {
      this.inputs = inputs;
    } else {
      this.inputs = [];
    }
  }
}

export class orderStatusReportRequest {
  customerNumber:string;
  shipToParty: string;
  marketName:string;
  constructor(customerNumber: string,shipToParty:string) {
    this.customerNumber = customerNumber;
    this.shipToParty = shipToParty;
  }
}

export class worksheetStatusReportRequest {
  customerNumber:string;
  marketId: string;
  marketName:string;
  projectId:string;
  projectName:string;
  constructor(customerNumber: string,marketId:string,marketName:string,projectId:string,projectName:string) {
    this.customerNumber = customerNumber;
    this.marketId = marketId;
    this.marketName = marketName;
    this.projectId = projectId;
    this.projectName = projectName;
  }
}

export class taskStatusReportRequest {
  customerNumber:string;
  marketId: string;
  marketName:string;
  projectId:string;
  projectName:string;
  taskType:string;
  startDate: string;
  endDate: string;
  constructor(customerNumber: string,marketId:string,marketName:string,projectId:string,projectName:string,taskType:string) {
    this.customerNumber = customerNumber;
    this.marketId = marketId;
    this.marketName = marketName;
    this.projectId = projectId;
    this.projectName = projectName;
    this.taskType = taskType;
  }
}

export class OrderScheduleLines {
  salesOrderNumber: string;
  itemNumber: string;
  confirmedQty: number;
  unConfirmedQty: number;
  qtyShipped: number;
  displayQuantity: number;
  expectedShipDate: string;
}






// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/api/models/project-summary.ts